/* eslint-disable */

import config from '@/config'

export const WO_HEADER_FOOTER = 'woHeaderFooter'
export const APP_FLAG = 'source=salesapp'
export const DOU_YIN_FLAG = 'source=douyinmnp'
export const PREVIEW_FLAG = 'previewId'
export const DISPLAY_FLAG = 'display'

export const PC_HEADER_HEIGHT = 72
export const MOBILE_FOOTER_HEIGHT = 106
export const MOBILE_HEADER_HEIGHT = 64
export const PC_MOBILE_BREAKPOINT = 1024
export const PC_MOBILE_BREAKPOINT_USED_CAR = 768
export const ACTIVITY_CID_EXPIRE_TIME = 90

// 增量静态再生配置，设置每 60 秒重新生成一次页面
export const REVALIDATE = 60

export const LOGIN_URL = config.E_STORE_HOST + '/newciam/api/v1/auth/redirect?site=onewebng&lang=zh-CN&cntxt=login&mode=in-place'
export const LOGOUT_URL = config.E_STORE_HOST + '/newciam/api/v1/auth/redirect?site=onewebng&lang=zh-CN&cntxt=logout&mode=in-place'
export const EDIT_PHONE_URL = config.E_STORE_HOST + '/newciam/api/v1/auth/redirect?site=onewebng&lang=zh-CN&cntxt=profile-mobile&mode=in-place'
export const UNBIND_URL = config.E_STORE_HOST + '/newciam/api/v1/auth/redirect?site=onewebng&lang=zh-CN&cntxt=unbind-idp&mode=in-place'
export const CANCEL_LOGIN_URL = config.E_STORE_HOST + '/newciam/api/v1/auth/redirect?site=onewebng&lang=zh-CN&cntxt=profile-delete&mode=in-place'
export const LOGOUT_SAFARI_URL = config.E_STORE_HOST + '/newciam/api/v1/auth/redirect?site=onewebng&lang=zh-CN&cntxt=post-logout&mode=in-place'


export enum PermissionType {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
  BROWSER_DENIED = 'BROWSER_DENIED'
}

export enum PageType {
  ENGINE = 'engine',
  MODAL = 'modal'
}

export enum LegalKeys {
  UNABLE_TO_LOCATE = 'popup_notification_unable_to_locate',
  LOCATION_APPROVAL = 'popup_ask_approval_for_location_request',
  MODEL_FILTER = 'suffix_disclaimer_model_filter',
  FAST_ASSESSMENT_TIP = 'used_car_fast_agreement_legal'
}

export enum KEYS {
  CAPTCHA_ID = 'cac95faf89ba46ab9538987f1c44cae2'
}
